






















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { widgetItems, parseConfig, parseColNum } from '../render';
import { IActions, IWidgets } from '@/store/home/stats/types';
import WidgetSettings from '@/views/home/common/Settings.vue';
import ClientUsage from '@/views/home/block/client-usage/ClientUsage.vue';
import ClientCrash from '@/views/home/block/client-crash/ClientCrash.vue';
import OssDownload from '@/views/home/block/oss-download/OssDownload.vue';
import LoginThresh from '@/views/home/block/login-thresh/LoginThresh.vue';
import DpgIncrement from '@/views/home/block/dpg-Increment/DpgIncrement.vue';

const Stats = namespace('home/stats');

// 平台首页
@Component({
  components: { WidgetSettings, ClientUsage, ClientCrash, OssDownload, LoginThresh, DpgIncrement },
})
export default class PlatformHome extends Vue {
  @Stats.Action('queryWidgetList') public queryWidgetList!: IActions['queryWidgetList'];
  @Stats.Mutation('setWidgetList') public setWidgetList!: IActions['setWidgetList'];
  @Stats.State('widgetList') public widgetList!: IWidgets;

  public winWidth = 0;

  // 小组件列表
  public get items() {
    return this.widgetList.data.map((item) => {
      const userId = item.userId || null;
      const configId = item.configId || null;
      const code = item.widgetCode || '';
      const config = parseConfig(item.config);
      const data = widgetItems.find((widget) => widget.code === code);
      const name = data?.name || '';
      const title = data?.title || '';
      return { userId, configId, code, name, title, config };
    }).sort((a, b) => {
      // 从小到大排序，-1排最后面
      const aSort = a.config.sortNo;
      const bSort = b.config.sortNo;
      if (aSort === -1) { return 1; }
      if (bSort === -1) { return -1; }
      return aSort - bSort;
    });
  }

  public created() {
    this.queryWidgetList();
  }

  public mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.setWidgetList({ data: [] });
  }

  // 计算响应式列宽
  public cols(record: any) {
    const colNum = record.config.cols;
    return parseColNum(colNum, this.winWidth);
  }

  // 窗口缩放时
  public onResize() {
    this.winWidth = window.innerWidth;
  }
}
